import React from 'react'

type Props = {
    openOptions: (e: React.MouseEvent) => void
}

export function ElementOptionsIcon({ openOptions }: Props) {
    return (
        <button
            data-testid={'element-options-button'}
            className={'AppCore__flow__FeedbackIcon'}
            onClick={(e) => {
                e.stopPropagation()
                openOptions(e)
            }}
        >
            <zaptic-icon icon-name={'ellipsis'} />
        </button>
    )
}
